export default {
  isYouTube: function (url) {
    return ((url.indexOf('youtube') > 0)||(url.indexOf('youtu.be') > 0))
  },
  isVimeo: function (url) {
    return url.indexOf('vimeo.com') > 0
  },
  getVimeoCode: function (url) {
    let strs = url.split('/')
    return strs.pop()
  },
  getYoutubeCode: function (url) {
    if (this.isYouTube(url) ) {
      let strs = url.split('?')
      if(strs.length > 1) {
        return this.handleParamaterizedYoutubeUrl(strs[1])
      }
      else {
        return this.handlePathYouTubeUrl(url)
      }
    }
  },
  handlePathYouTubeUrl: function (url) {
    let chunks = url.split('/');
    return chunks.pop()
  },
  handleParamaterizedYoutubeUrl: function (parms) {
    let arr = parms.split('&')
    for(let item of arr) {
      if(item.startsWith('v=')){
        let cds = item.split('=')
        if(cds.length > 1) return cds[1]
      }
    }
  },
  getYoutubeThumbnail: function (url) {
    let code = this.getYoutubeCode(url)
    return `https://img.youtube.com/vi/${code}/hqdefault.jpg`
  },
  getVideoPlayer: function (url) {
    if(this.isYouTube(url)) {
      let code = this.getYoutubeCode(url) 

      return `<iframe class="video-frame" src="https://www.youtube.com/embed/${code}" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
    }
    return 'Not You Tube'
  }
  
}